import { NoEditPlugin } from '@src/slide/application/no-edit/plugins/no-edit-plugin';
import { ILoginPlugin } from '@src/slide/application/no-edit/plugins/login/login-plugin.interface';
import { UserInfo } from '@tencent/docs-login/dist/utils/user';
import { authenticate, isLogin, loginOnce, logout, getUid, getUidKey } from '@tencent/docs-login';
import setUserInfoForClientVars from '@src/slide/application/no-edit/plugins/login/user-info-util';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { shouldDisableNetwork } from '@src/slide/infrastructure/module/dependent/socket';

/**
 * 非编辑浏览登录plugin
 */
export default class LoginPlugin extends NoEditPlugin implements ILoginPlugin {
    public userInfo: UserInfo | undefined;
    private authenticateRequest: Promise<UserInfo | undefined>;

    public initPlugin(): void {
        if (shouldDisableNetwork()) {
            this.authenticateRequest = Promise.resolve(undefined);
            return;
        }
        this.authenticateRequest = authenticate({
            fetchUserInfo: true,
            // 云编预览场景不触发自动登录。否则Iframe中弹登录框会登录失败
            autoLogin: !this.editExtensionService?.isPreviewDriveDocs(),
        });
        this.getUserInfo().then((user: UserInfo | undefined) => {
            this.userInfo = user;
            window.clientVars = window.clientVars || {};
            window.clientVars.isLogin = true;
            window.clientVars.userType = user?.loginType;
            window.clientVars.uidKey = this.getUidKey();
            setUserInfoForClientVars(window.clientVars, user);
            eventBus.emit(EventKeys.LOGIN_USER_INFO_READY_EVENT, this.userInfo);
        });
    }

    /**
     * 获取缓存的用户信息，异步获取
     */
    public async getUserInfo(): Promise<UserInfo | undefined> {
        const userInfo = await this.authenticateRequest;
        return userInfo?.nick ? userInfo : this.buildUserInfoFromClientVars();
    }

    /**
     * 是否是登录态
     */
    public isLogin(): boolean {
        return isLogin();
    }

    /**
     * 触发登录动作。
     */
    public async login(): Promise<void> {
        await loginOnce();
        return Promise.resolve();
    }

    public logout(): void {
        return logout();
    }

    public getUid(): string {
        return getUid() || '';
    }

    public getUidKey(): string {
        return getUidKey() || '';
    }

    /**
     * 拉取用户信息结束回调
     * @param callback
     */
    public onUserReady(callback: (data: any) => void) {
        eventBus.on(EventKeys.LOGIN_USER_INFO_READY_EVENT, callback);
    }

    /**
     * 对于中台等特殊场景 authenticate 方法可能无法正确返回用户信息此时先从 clientVars 中提取基本信息就可以了
     */
    private async buildUserInfoFromClientVars(): Promise<UserInfo> {
        const {
            corp_id: corpId,
            corp_name: corpName,
            fullName,
            loginType,
            tinyid,
            userPic,
        } = window.clientVars?.userInfo || {};
        // @ts-expect-error 仅有这些有效信息，有需要再补充
        const userInfo: UserInfo = {
            corpId,
            corpName,
            loginType,
            nick: fullName,
            userName: fullName,
            userPic,
            avatar: userPic,
            tinyId: tinyid,
            uid: tinyid,
        };
        return userInfo;
    }
}
